// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"245e8bbc","453":"d6b2935d"}[chunkId] + ".chunk.js";
};